import React, {useState} from "react";
import PropTypes from "prop-types";
import { 
  withStyles,
  Typography,
  AppBar,
  Button,
  Toolbar,
  Drawer,
  List,
  ListItem,
  IconButton,
 } from "@material-ui/core";
 import {withRouter} from 'react-router-dom';
 import {Row, Col} from 'react-flexbox-grid';
 import MenuIcon from "@material-ui/icons/Menu";

const styles = {
  root: {
    flexGrow: 1
  },
  grow: {
    flexGrow: 1
  },
  appBar : {
    backgroundColor : 'white',
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 0.58,
    shadowRadius: 16.00,

    elevation: 24,
    padding : 4,
  },
  button : {
    textTransform  : 'none',
    margin : 4
  },
  text : {
    color : '#0D6939',
    fontFamily : "'Poppins', sans-serif"
  },
  logo: {
    maxWidth: 240
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
    color : "#009688"
  },
  textMenu : {
    fontFamily : "'Poppins', sans-serif",
    fontSize : 15
  }
};

/**
 * Jhoan López <jhoanlt19@gmail.com>
 * Barra de menú sencilla para la landing page
 * @param {*} param0
 */
const SimpleMenuBar = ({classes, selectedMenuItem, history}) => {

  const [openDrawer, setOpenDrawer] = useState(false);
  const [isAuth, setIsAuth] = useState(localStorage.getItem("token"));

  function redirect(item, path=null) {
    localStorage.setItem("indicatorType", JSON.stringify(item));
    history.push(
      path ? { pathname: path } :
     { pathname: '/home', params: { indicatorType: item } }
    )
  }

  function toggleDrawer(item=null){
    if(item){
      selectedMenuItem(item);
    }
    setOpenDrawer(!openDrawer);
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
      <Toolbar>
        <IconButton
          className={classes.menuButton}
          color="inherit"
          aria-label="Menu"
          onClick={() => toggleDrawer()}
        >
          <MenuIcon />
        </IconButton>
        <img 
          src="https://vgde-files.s3.amazonaws.com/landing-image-5.png" 
          alt="logo"
          width="180" 
          height="80"
        />
        <Typography className={classes.grow}></Typography>
        {isAuth ? 
          <Button
            variant="outlined" 
            color="primary"
            className={classes.button}
            onClick={() => {
              localStorage.removeItem("token");
              setIsAuth(false);
              redirect(null, '/');
            }}
          >
            Cerrar sesión
          </Button> : 
          <Button
            variant="outlined" 
            color="primary"
            className={classes.button}
            onClick={() => redirect(null, '/login')}
          >
            Login
          </Button>
        }
        </Toolbar>
      </AppBar>
      <Drawer open={openDrawer} onClose={() => toggleDrawer()}>
          <List>
            <ListItem>
              <Row center="xs" className={classes.logo}>
                <Col xs={12} className="flex justify-center">
                  <img 
                    src="https://vgde-files.s3.amazonaws.com/LogoFacultadNacionaldeSaludPublica.png"  
                    alt="logo" 
                    width="180" 
                    height="80" 
                  />
                </Col>
                <Col xs={12}>
                  <Typography className={classes.text} variant="caption">Grupo de Investigación de Epidemiología</Typography>
                </Col>
              </Row>
            </ListItem>
            <ListItem button onClick={() => toggleDrawer('LANDING')}>
              <Typography className={classes.textMenu}>Inicio</Typography>
            </ListItem>
            <ListItem
              button
              onClick={() => toggleDrawer("PROJECT")}
            >
              <Typography className={classes.textMenu}>El proyecto</Typography>
            </ListItem>
            <ListItem
              button
              onClick={() => toggleDrawer('CREDITS')}
            >
              <Typography className={classes.textMenu}>Créditos</Typography>
            </ListItem>
            <ListItem
              button
              onClick={() => toggleDrawer('METHODOLOGY')}
            >
              <Typography className={classes.textMenu}>Metodología</Typography>
            </ListItem>
            <ListItem
              button
              onClick={() => toggleDrawer('RESEARCHERS')}
            >
              <Typography className={classes.textMenu}>Investigadores</Typography>
            </ListItem>
            <ListItem
              button
              onClick={() => toggleDrawer('PUBLICATIONS')}
            >
              <Typography className={classes.textMenu}>Publicaciones</Typography>
            </ListItem>
            <ListItem button onClick={() => toggleDrawer('FAQ')}>
              <Typography className={classes.textMenu}>Preguntas frecuentes</Typography>
            </ListItem>
            <ListItem
              button
              onClick={() => toggleDrawer('REFERENCES')}
            >
              <Typography className={classes.textMenu}>Citando el atlas</Typography>
            </ListItem>
          </List>
        </Drawer>
    </div>
  );
}

SimpleMenuBar.propTypes = {
  classes : PropTypes.object.isRequired,
  history : PropTypes.object 
};

export default withRouter(withStyles(styles)(SimpleMenuBar));



// WEBPACK FOOTER //
// ./src/components/menuBar/simpleMenuBar.js